var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.data.action.date)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('flowTemplate.forms.mailing.summary', { delay: _vm.delay, }))+" ")]):_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }